/* tslint:disable */
/* eslint-disable */
/**
 * Sds Web
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    OutBop,
    OutBopFromJSON,
    OutBopFromJSONTyped,
    OutBopToJSON,
} from './';

/**
 * 
 * @export
 * @interface ConfigBop
 */
export interface ConfigBop {
    /**
     * 
     * @type {OutBop}
     * @memberof ConfigBop
     */
    bop: OutBop;
    /**
     * 
     * @type {Array<string>}
     * @memberof ConfigBop
     */
    configErrors: Array<string>;
}

export function ConfigBopFromJSON(json: any): ConfigBop {
    return ConfigBopFromJSONTyped(json, false);
}

export function ConfigBopFromJSONTyped(json: any, ignoreDiscriminator: boolean): ConfigBop {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bop': OutBopFromJSON(json['bop']),
        'configErrors': json['configErrors'],
    };
}

export function ConfigBopToJSON(value?: ConfigBop | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bop': OutBopToJSON(value.bop),
        'configErrors': value.configErrors,
    };
}


